import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import CloseIconButton from 'Src/components/buttons/CloseIconButton';
import CTA from 'Src/components/buttons/CTA';
import Copy from 'Src/components/Copy';
import { HeaderMainNav } from 'Src/components/navigation/HeaderMainNav';
import { useModalSearchParamControl } from 'Src/feature/modal/useModalControl';
import { Page } from 'Src/feature/page/Page';
import { PageMain } from 'Src/feature/page/PageMain';
import { PageMainHeader } from 'Src/feature/page/PageMainHeader';
import useRoute from 'Src/routes/useRoute';

import { PayInOutList } from './PayInOutList';
import { PayInView } from './PayInView';
import { PayOutView } from './PayOutView';

import styles from './PayInOutPage.module.scss';

const sectionId = 'PayInOutPage';
const PayInOutPage: FC = () => {
  const { t } = useTranslation();
  const { crumbs, navigate, route } = useRoute();

  const payInModal = useModalSearchParamControl({ value: 'pay-in' });
  const payOutModal = useModalSearchParamControl({ value: 'pay-out' });
  const payInOutListModal = useModalSearchParamControl({ value: 'pay-in-out-list' });

  return (
    <>
      <Page
        main={(
          <PageMain
            header={(
              <PageMainHeader
                start={(
                  <>
                    <CloseIconButton onClick={() => navigate(crumbs.pos.checks.main.interpolate({ tabId: route.params.value.checksList }))}/>
                    <Copy variant="h6" value={t('payInOut.label')} />
                  </>
                )}
                end={<HeaderMainNav />}
              />
            )}
            main={(
              <div className={styles.root}>
                <Copy color="textSecondary" align="center" value={t('payInOut.labels.selectOperationType')}/>
                <CTA
                  data-testid={`${sectionId}-pay-in-btn`}
                  onClick={() => payInModal.open()}
                  label={t('payInOut.labels.payIn')}
                />
                <CTA
                  data-testid={`${sectionId}-pay-out-btn`}
                  onClick={() => payOutModal.open()}
                  label={t('payInOut.labels.payOut')}
                />
                <CTA
                  data-testid={`${sectionId}-pay-in-out-log-btn`}
                  color="secondary"
                  onClick={() => payInOutListModal.open()}
                  label={t('payInOut.labels.viewLog')}
                />
              </div>
            )}
          />
        )}
      />
      {/* ----- MODALS -----  */}
      <PayInView baseModalControl={payInModal}/>
      <PayOutView baseModalControl={payOutModal}/>
      <PayInOutList payInOutListModal={payInOutListModal}/>
    </>
  );
};

export default PayInOutPage;
export { sectionId };
